import type { ReactNode } from 'react';

export const renderRichListItem = (chunks: ReactNode) => (
  <div className="relative pl-7">
    <span aria-hidden="true" className="absolute top-[0.6em] left-2 h-1.5 w-1.5 rounded-full bg-current" />
    <div>{chunks}</div>
  </div>
);
